import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { Feature, Role, Tenant } from '../../../models/cube';
import { CubeAuth } from '../../../module_b2c_login/CubeAuth';

import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  token: BehaviorSubject<string | undefined> = new BehaviorSubject<
    string | undefined
  >(undefined);
  profile: BehaviorSubject<string | undefined> = new BehaviorSubject<
    string | undefined
  >(undefined);

  constructor(private readonly http: HttpClient) {}

  tenants(uniqueId: string): Observable<Array<Tenant>> {
    return this.http.get<Array<Tenant>>(
      `${environment.ADMIN_TOOL_URL}/users/${uniqueId}/solutions/${environment.SOLUTION}/tenants`
    );
  }

  roles(uniqueId: string, tenant: string): Observable<Array<Role>> {
    return this.http.get<Array<Role>>(
      `${environment.ADMIN_TOOL_URL}/tenants/${tenant}/users/${uniqueId}/platforms/CUBE/solutions/${environment.SOLUTION}/roles`
    );
  }

  features(role: string, tenant: string): Observable<Array<Feature>> {
    return this.http.get<Array<Feature>>(
      `${environment.ADMIN_TOOL_URL}/tenants/${tenant}/roles/${role}/platforms/CUBE/solutions/${environment.SOLUTION}/features`
    );
  }

  login() {
    /*     this.msalService.loginRedirect();
     */
    CubeAuth.enableADB2C(
      environment.b2cPolicies.tenant,
      environment.b2cPolicies.clientId,
      environment.b2cPolicies.names.signUpSignIn,
      environment.b2cPolicies.redirectUri,
      environment.b2cPolicies.b2cLoginBaseUrl
    );
    CubeAuth.setLogutRedirectUri(environment.b2cPolicies.postLogoutRedirectUri);

    CubeAuth.onADB2CNewToken = (
      idToken: any,
      expires: any,
      profileInfo: any
    ) => {
      this.token.next(idToken);
      this.profile.next(profileInfo.name);
    };

    CubeAuth.auth();
  }

  logout() {
    /*     this.msalService.logoutRedirect();
     */

    CubeAuth.logout();
    this.profile.next(undefined);
    this.token.next(undefined);
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
  }

  // isValidToken(expiration: number | undefined): boolean {
  //   const margin = 300 * 1000; // 300 seconds or 5 minutes in milliseconds
  //   const adjustedExpiration = (expiration ?? 1) * 1000 - margin;
  //   return Date.now() <= adjustedExpiration;
  // }

  resourceNeedsToken(request_url: string): boolean {
    return environment.bypass_auth_token_resources.every(
      (resource) => !request_url.includes(resource)
    );
  }

  // cloneRequest(
  //   req: HttpRequest<unknown>,
  //   idToken: string,
  //   append_token: boolean
  // ): HttpRequest<unknown> {
  //   if (append_token) {
  //     const clonedReq = req.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${idToken}`,
  //       },
  //     });

  //     return clonedReq;
  //   } else {
  //     return req;
  //   }
  // }
}
